<ion-content> 
<button no-padding ion-button (click)="closeSearch($event)">
    <ion-icon name="search"></ion-icon>
  </button>
  <search-tabs></search-tabs>
</ion-content>
